var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15996_51780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8978 0.0326705L18.0001 6.78339L5.16582 6.73941C5.02874 6.74468 4.93146 6.74908 4.81826 6.77987C4.34599 6.90916 4.16558 7.40348 4.1868 7.73684C4.20272 7.99983 4.37783 8.25403 4.55383 8.45105L11.0576 15.7761H5.55672L1.38417 11.1355C0.554612 10.1653 0.0505092 8.95065 0.00363646 7.67791C-0.0715367 5.603 1.02953 4.2854 2.30924 3.51666C3.25377 2.94933 4.34688 2.67139 5.4506 2.67139H11.3229V0.340521C11.3229 -0.046491 11.7059 -0.0262608 11.8978 0.0326705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10229 23.9681L0 17.2174L12.8343 17.2613C12.9714 17.2561 13.0686 17.2517 13.1818 17.2209C13.6541 17.0916 13.8345 16.5973 13.8133 16.2639C13.7974 16.0009 13.6223 15.7467 13.4463 15.5497L6.94247 8.22461H12.4434L16.6159 12.8661C17.4455 13.8363 17.9496 15.051 17.9965 16.3237C18.0716 18.3986 16.9706 19.7162 15.6909 20.485C14.7463 21.0523 13.6532 21.3302 12.5495 21.3302H6.67715V23.6611C6.67715 24.0481 6.29421 24.0279 6.10229 23.9689V23.9681Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15996_51780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swap-icon.e0e4d46240ec64f54d6f890520548346.svg";
export { ForwardRef as ReactComponent };